import React, {useState} from "react";
import {ButtonIcon, ButtonIconExport, getErrorMessageByKey, Loading, useNotification} from "@vokymlak/kabinet-ui";
import {ScrollBlock} from "../../../components/ScrollBlock/ScrollBlock";
import {ROOT_URL} from "../../../config/url";
import ModalUploadCompanyKey from "./ModalUploadCompanyKey";
import ModalDeleteCompanyKey from "./ModalDeleteCompanyKey";
import ModalUploadCompanyCsr from "./ModalUploadCompanyCsr";
import ModalDeleteCompanyCsr from "./ModalDeleteCompanyCsr";
import ModalAddClientId from "./ModalAddClientId";
import ModalDeleteClientId from "./ModalDeleteClientId";
import ModalUploadCompanyCer from "./ModalUploadCompanyCer";
import ModalDeleteCompanyCer from "./ModalDeleteCompanyCer";
import moment from "moment";
import ModalDeleteCompanyKeyPem from "./ModalDeleteCompanyKeyPem";
import ModalUploadCompanyKeyPem from "./ModalUploadCompanyKeyPem";
import axios from "axios";
import ModalDeleteCaCertificatePem from "./ModalDeleteCaCertificatePem";
import ModalDeleteClientSecret from "./ModalDeleteClientSecret";
import ModalDeleteAuthorizeCode from "./ModalDeleteAuthorizeCode";
import ModalAddAuthorizeCode from "./ModalAddAuthorizeCode";
import ModalDeleteAccountNumber from "./ModalDeleteAccountNumber";
import ModalAddAccountNumber from "./ModalAddAccountNumber";
import ModalGetOrganization from "./ModalGetOrganization";
import ModalGetTransactions from "./ModalGetTransactions";

const CertificateStatus = ({after, before}) => {
  const currentDate = moment();
  const startDate = moment(after, "YYYY-MM-DD HH:mm:ss");
  const endDate = moment(before, "YYYY-MM-DD HH:mm:ss");

  // Проверяем состояние сертификата
  const isExpiringSoon = endDate.diff(currentDate, "days") <= 90;
  const isValid = currentDate.isBetween(startDate, endDate);

  // Цвет текста и рамки
  const statusColor = isValid
    ? isExpiringSoon
      ? "red"
      : "green"
    : "gray";

  // Стили для компонента
  const containerStyle = {
    padding: 8,
    border: `1px solid ${statusColor}`,
    borderRadius: 7,
    color: statusColor,
    fontSize: 16,
  };

  return (
    <div style={containerStyle}>
      <p>
        <span>Начало действия:</span> {startDate.format("DD.MM.YYYY")}
      </p>
      <p>
        <span>Конец действия:</span> {endDate.format("DD.MM.YYYY")}
      </p>
      <p>
        <span>Статус:</span>{" "}
        {isValid
          ? isExpiringSoon
            ? "Скоро истечет"
            : "Действителен"
          : "Недействителен"}
      </p>
    </div>
  );
};

function IntegrationAlfabankPage(props) {
  const {
    object,

    setIsUpdateObject,
    isUpdateObject,
  } = props;

  const [isModalUploadCompanyKey, setIsModalUploadCompanyKey] = useState(false);
  const [isModalDeleteCompanyKey, setIsModalDeleteCompanyKey] = useState(false);
  const [isModalUploadCompanyCsr, setIsModalUploadCompanyCsr] = useState(false);
  const [isModalDeleteCompanyCsr, setIsModalDeleteCompanyCsr] = useState(false);

  const [isModalAddClientId, setIsModalAddClientId] = useState(false);
  const [isModalDeleteClientId, setIsModalDeleteClientId] = useState(false);
  const [isModalUploadCompanyCer, setIsModalUploadCompanyCer] = useState(false);
  const [isModalDeleteCompanyCer, setIsModalDeleteCompanyCer] = useState(false);
  const [isModalUploadCompanyKeyPem, setIsModalUploadCompanyKeyPem] = useState(false);
  const [isModalDeleteCompanyKeyPem, setIsModalDeleteCompanyKeyPem] = useState(false);
  const [isModalDeleteCaCertificatePem, setIsModalDeleteCaCertificatePem] = useState(false);
  const [isModalDeleteClientSecret, setIsModalDeleteClientSecret] = useState(false);
  const [isModalAddAuthorizeCode, setIsModalAddAuthorizeCode] = useState(false);
  const [isModalDeleteAuthorizeCode, setIsModalDeleteAuthorizeCode] = useState(false);
  const [isModalAddAccountNumber, setIsModalAddAccountNumber] = useState(false);
  const [isModalDeleteAccountNumber, setIsModalDeleteAccountNumber] = useState(false);

  const [isModalGetOrganization, setIsModalGetOrganization] = useState(false);
  const [isModalGetTransactions, setIsModalGetTransactions] = useState(false);

  const {notification} = useNotification();

  const changeAddCaCertificatePem = () => {
    axios
      .get(
        "/api/alfabank/add/ca-certificate-pem",
        {
          withCredentials: false,
          baseURL: ROOT_URL,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem("tokenSession"),
          },
        }
      )
      .then(() => {
        setIsUpdateObject(!isUpdateObject);
        notification("Получена цепочка корневых сертификатов CA", "green");
      })
      .catch((error) => {
        setIsUpdateObject(!isUpdateObject);
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changeAddClientSecret = () => {
    axios
      .get(
        "/api/alfabank/add/client-secret",
        {
          withCredentials: false,
          baseURL: ROOT_URL,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem("tokenSession"),
          },
        }
      )
      .then(() => {
        setIsUpdateObject(!isUpdateObject);
        notification("Получен новый секретный ключ", "green");
      })
      .catch((error) => {
        setIsUpdateObject(!isUpdateObject);
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    <ScrollBlock style={{width: "100%", height: "100%"}}>
      <div className="Page">
        <div className="Page__title">
          <div
            className="Title__text"
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 21,
              fontWeight: 700,
            }}
          >
            Интеграция с Альфабанк
          </div>

          <div className="Title__settings">
            <ButtonIcon
              tooltipText={"Обновить"}
              iconName={"custom-change-circle"}
              iconColor={"#20202075"}
              size={28}
              style={{marginLeft: 8}}
              onClick={() => (setIsUpdateObject(!isUpdateObject))}
            />
          </div>
        </div>

        {!object && (
          <div className={"Page__loader"}>
            <Loading/>
          </div>
        )}

        {!!object && (
          <div className="Page__content">
            <div className="Form" style={{
              marginBottom: 32
            }}>
              <div className="Form__title">
                Выпуск сертификата
                <div className="Text__signature">Для Альфабанка</div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  Повторный выпуск!
                </div>
                <div className="Field__text">
                  Для повторного выпуска сертификата необходимо не ранее, чем за три месяца, и не позднее,<br/>
                  чем за один месяц до истечения действия сертификата,
                  сформировать и направить запрос на сертификат в Банк.<br/>
                  Контроль за сохранностью и сроками действия сертификатов возлагается на Вас.
                </div>
                <div className="Field__text">
                  Дополнительно по выпуску сертификата читать&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/connection/articles/tls/tls"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >тут</a>
                </div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  1. Генерируем закрытый ключ в консоли
                </div>
                <div className="Field__text">
                  openssl genrsa -des3 -out Company.key 2048
                  <br/>
                  pass: 5933010849
                </div>
              </div>

              {!object.company_key && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalUploadCompanyKey(true)}>
                    Прикрепить
                  </button>
                </div>
              )}
              {!!object.company_key && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    Company.key
                    <ButtonIconExport
                      tooltipText={"Выгрузить"}
                      iconName={"custom-download"}
                      iconColor={"#202020"}
                      size={24}
                      style={{marginLeft: 12}}
                      apiUrl={"/api/alfabank/company-key"}
                      rootUrl={ROOT_URL}
                      mimeType={"text/plain; charset=utf-8"}
                      fileName={"Company.key"}
                    />
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteCompanyKey(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  2. Скачиваем файл openssl_INN.cnf
                </div>
                <div className="Field__text" style={{
                  display: "flex",
                  alignItems: "center"
                }}>
                  openssl_INN.cnf
                  <ButtonIconExport
                    tooltipText={"Выгрузить"}
                    iconName={"custom-download"}
                    iconColor={"#202020"}
                    size={24}
                    style={{marginLeft: 12}}
                    apiUrl={"/api/alfabank/file/openssl_INN"}
                    rootUrl={ROOT_URL}
                    mimeType={"text/plain; charset=utf-8"}
                    fileName={"openssl_INN.cnf"}
                  />
                </div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  3. Генерируем сертификат запроса на основе закрытого ключа
                </div>
                <div className="Field__text">
                  openssl req -utf8 -config openssl_INN.cnf -key Company.key -new -sha256 -out Company.csr
                  <br/>
                  <br/>
                  countryName - RU
                  <br/>
                  localityName - Kozmodemyansk
                  <br/>
                  organizationName - AGROPRODUCT
                  <br/>
                  Common Name - Ismagilov Vasil Vasilevich
                  <br/>
                  Email Address - 2041818@mail.ru
                  <br/>
                  INN - пропускаем
                  <br/>
                  INNLE - 5933010849
                  <br/>
                  SNILS - пропускаем
                  <br/>
                  и остальное тоже пропускаем через Enter
                </div>
              </div>

              {!object.company_csr && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalUploadCompanyCsr(true)}>
                    Прикрепить
                  </button>
                </div>
              )}
              {!!object.company_csr && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    Company.csr
                    <ButtonIconExport
                      tooltipText={"Выгрузить"}
                      iconName={"custom-download"}
                      iconColor={"#202020"}
                      size={24}
                      style={{marginLeft: 12}}
                      apiUrl={"/api/alfabank/company-csr"}
                      rootUrl={ROOT_URL}
                      mimeType={"text/plain; charset=utf-8"}
                      fileName={"Company.csr"}
                    />
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteCompanyCsr(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  4. Проверяем все ли верно в сертификате запроса
                </div>
                <div className="Field__text">
                  openssl req -config openssl_INN.cnf -noout -text -in Company.csr
                </div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  5. Переименовываем сертификат запроса в agroproduct.csr и отправляем в Альфабанк
                </div>
                <div className="Field__text">
                  на почту alfa_api@alfabank.ru
                </div>
              </div>
            </div>

            <div className="Form">
              <div className="Form__title">
                Подключение к АПИ
                <div className="Text__signature">Альфабанка</div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  1. Вводим выданный ключ к апи (clientId)
                </div>
                <div className="Field__text">
                </div>
              </div>

              {!object.client_id && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalAddClientId(true)}>
                    Указать
                  </button>
                </div>
              )}
              {!!object.client_id && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    {object.client_id.value}
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteClientId(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  2. Загружаем выпущенный сертификат на компанию (Agroproduct_2024.cer)
                </div>
                <div className="Field__text">
                </div>
              </div>

              {!object.company_cer && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalUploadCompanyCer(true)}>
                    Прикрепить
                  </button>
                </div>
              )}
              {!!object.company_cer && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    Company.cer
                    <ButtonIconExport
                      tooltipText={"Выгрузить"}
                      iconName={"custom-download"}
                      iconColor={"#202020"}
                      size={24}
                      style={{marginLeft: 12}}
                      apiUrl={"/api/alfabank/company-cer"}
                      rootUrl={ROOT_URL}
                      mimeType={"text/plain; charset=utf-8"}
                      fileName={"Company.cer"}
                    />
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteCompanyCer(true)
                      }
                    />
                  </div>
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <CertificateStatus after={object.company_cer.before} before={object.company_cer.after}/>
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  3. Получаем company_key.pem из Company.key и загружаем
                </div>
                <div className="Field__text">
                  openssl rsa -in Company.key -out company_key.pem
                  <br/>
                  pass 5933010849
                </div>
              </div>

              {!object.company_key_pem && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalUploadCompanyKeyPem(true)}>
                    Прикрепить
                  </button>
                </div>
              )}
              {!!object.company_key_pem && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    company_key.pem
                    <ButtonIconExport
                      tooltipText={"Выгрузить"}
                      iconName={"custom-download"}
                      iconColor={"#202020"}
                      size={24}
                      style={{marginLeft: 12}}
                      apiUrl={"/api/alfabank/company-key-pem"}
                      rootUrl={ROOT_URL}
                      mimeType={"text/plain; charset=utf-8"}
                      fileName={"company_key.pem"}
                    />
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteCompanyKeyPem(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  3. Получить или обновить цепочку корневых сертификатов CA
                </div>
                <div className="Field__text">
                  openssl s_client -showcerts -connect baas.alfabank.ru:443 (команда для проверки)
                </div>
              </div>

              {!object.ca_certificate_pem && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => changeAddCaCertificatePem()}>
                    Получить
                  </button>
                </div>
              )}
              {!!object.ca_certificate_pem && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    ca_certificates.pem
                    <ButtonIconExport
                      tooltipText={"Выгрузить"}
                      iconName={"custom-download"}
                      iconColor={"#202020"}
                      size={24}
                      style={{marginLeft: 12}}
                      apiUrl={"/api/alfabank/ca-certificate-pem"}
                      rootUrl={ROOT_URL}
                      mimeType={"text/plain; charset=utf-8"}
                      fileName={"ca_certificates.pem"}
                    />
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteCaCertificatePem(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  4. Тест всех загруженных сертификатов (обновите страницу)
                </div>
                <div className="Field__text">
                  {!object.is_success_certificates && (
                    <span style={{
                      color: "red"
                    }}>
                      Ошибка в комплекте сертификатов
                    </span>
                  )}
                  {object.is_success_certificates && (
                    <span style={{
                      color: "green"
                    }}>
                      Сертификаты успешно проверены
                    </span>
                  )}
                </div>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  5. Получаем секретный ключ (документация&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/connection/articles/clientsecret/clientsecret"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >Client secret</a>)
                </div>
                <div className="Field__text">
                </div>
              </div>

              {!object.client_secret && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => changeAddClientSecret()}>
                    Получить
                  </button>
                </div>
              )}
              {!!object.client_secret && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    {object.client_secret.value}
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteClientSecret(true)
                      }
                    />
                  </div>
                </div>
              )}


              <div className="Form__field">
                <div className="Field__label">
                  6. Переходим по ссылке и получаем временный код для авторизации (документация&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/alfa-id/articles/acf-h2h/articles/get-auth-code/v1/get-auth-code"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >Получение кода авторизации</a>)
                </div>
                <div className="Field__label">
                  Код авторизации имеет ĸоротĸий сроĸ жизни (по умолчанию равен 2 минуты),
                  за это время необходимо обменять его на тоĸен доступа.
                </div>

                {!object.client_id && (
                  <>
                    <div className="Field__text">
                      Нет clientId
                    </div>
                  </>
                )}
                {!!object.client_id && (
                  <>
                    <div className="Field__text">
                      1. Перейти по ссылке к <a
                      href={object.url_authorize}
                      // href={"https://id.alfabank.ru/oidc/authorize?client_id=" + object.client_id.value +
                      //   "&redirect_uri=http%3A%2F%2Flocalhost&response_type=code&scope=customer%20transactions&state=token"}
                      target={"_blank"}
                      className={"Action__link Action__link_blue"}
                    >авторизации в Альфабанк</a>
                    </div>
                    <div className="Field__text">
                      2. При успешном входе в адресной строке получаем данные<br/>
                      <span
                        style={{fontSize: 14}}>`http://localhost/?code=b02ac6b2-13b5-42bd-80e5-edf4012f6c6e&state=token`</span>
                    </div>
                    <div className="Field__text">
                      3. Вводим временный код после авторизации (code)
                    </div>
                  </>
                )}
              </div>

              {!object.authorize_code && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalAddAuthorizeCode(true)}>
                    Указать
                  </button>
                </div>
              )}
              {!!object.authorize_code && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    {object.authorize_code.value}
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteAuthorizeCode(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  7. Получаем токен доступа для авторизации в апи (документация&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/alfa-id/articles/acf-h2h/articles/get-access-token/v1/get-access-token"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >Получение токена доступа</a>)
                </div>
                <div className="Field__text">
                </div>
              </div>

              {(!object.token_id && !object.token_access && !object.token_refresh) && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => changeAddClientSecret()}>
                    Получить
                  </button>
                </div>
              )}
              {(!!object.token_id || !!object.token_access || !!object.token_refresh) && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    Токен авторизации
                    <span
                      style={{marginLeft: 4}}>{(!!object.token_access && " до " + moment(object.token_access.after).format("DD.MM.YYYY HH:mm")) || " истёк"}</span>
                  </div>
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    Токен восстановления
                    <span style={{marginLeft: 4}}>{(!!object.token_refresh && "(" +
                      ((!!object.token_refresh.attempt_number && object.token_refresh.attempt_number) || "0")
                      + "/2)")}</span>
                    <span
                      style={{marginLeft: 4}}>{(!!object.token_refresh && " до " + moment(object.token_refresh.after).format("DD.MM.YYYY HH:mm")) || " истёк"}</span>
                  </div>
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteClientSecret(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  8. Тестовый запрос для получение профиля организации (документация&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/customer-info/articles/customer-info/v2/customer-info"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >Получение профиля организации</a>)
                </div>
                <div className="Field__text">
                </div>
              </div>

              <div className="Form__actions" style={{
                marginBottom: 24
              }}>
                <button className="Action__button Action__button_mini Action__button_blue"
                        onClick={() => setIsModalGetOrganization(true)}>
                  Получить
                </button>
              </div>

              <div className="Form__field">
                <div className="Field__label">
                  9. Номер счёта для получения выписки
                </div>
                <div className="Field__text">
                </div>
              </div>

              {!object.account_number && (
                <div className="Form__actions" style={{
                  marginBottom: 24
                }}>
                  <button className="Action__button Action__button_mini Action__button_blue"
                          onClick={() => setIsModalAddAccountNumber(true)}>
                    Указать
                  </button>
                </div>
              )}
              {!!object.account_number && (
                <div className="Form__field">
                  <div className="Field__text" style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    {object.account_number.value}
                    <ButtonIcon
                      tooltipText={"Удалить"}
                      iconName={"custom-delete"}
                      iconColor={"#0064ff"}
                      style={{marginLeft: 12}}
                      size={32}
                      onClick={() =>
                        setIsModalDeleteAccountNumber(true)
                      }
                    />
                  </div>
                </div>
              )}

              <div className="Form__field">
                <div className="Field__label">
                  10. Тестовый запрос для получение выписки по указанному счёту на указанную дату (документация&nbsp;
                  <a
                    href={"https://developers.alfabank.ru/products/alfa-api/documentation/articles/transactions/articles/statement/v1/statement"}
                    target={"_blank"}
                    className={"Action__link Action__link_blue"}
                  >Получение выписки</a>)
                </div>
                <div className="Field__text">
                </div>
              </div>

              <div className="Form__actions" style={{
                marginBottom: 24
              }}>
                <button className="Action__button Action__button_mini Action__button_blue"
                        onClick={() => setIsModalGetTransactions(true)}>
                  Получить
                </button>
              </div>

            </div>
          </div>
        )}

        {!!isModalUploadCompanyKey && (
          <ModalUploadCompanyKey
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalUploadCompanyKey(false)}
          />
        )}

        {!!isModalDeleteCompanyKey && (
          <ModalDeleteCompanyKey
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteCompanyKey(false)}
          />
        )}

        {!!isModalUploadCompanyCsr && (
          <ModalUploadCompanyCsr
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalUploadCompanyCsr(false)}
          />
        )}

        {!!isModalDeleteCompanyCsr && (
          <ModalDeleteCompanyCsr
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteCompanyCsr(false)}
          />
        )}

        {!!isModalAddClientId && (
          <ModalAddClientId
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalAddClientId(false)}
          />
        )}

        {!!isModalDeleteClientId && (
          <ModalDeleteClientId
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteClientId(false)}
          />
        )}

        {!!isModalUploadCompanyCer && (
          <ModalUploadCompanyCer
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalUploadCompanyCer(false)}
          />
        )}

        {!!isModalDeleteCompanyCer && (
          <ModalDeleteCompanyCer
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteCompanyCer(false)}
          />
        )}

        {!!isModalUploadCompanyKeyPem && (
          <ModalUploadCompanyKeyPem
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalUploadCompanyKeyPem(false)}
          />
        )}

        {!!isModalDeleteCompanyKeyPem && (
          <ModalDeleteCompanyKeyPem
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteCompanyKeyPem(false)}
          />
        )}

        {!!isModalDeleteCaCertificatePem && (
          <ModalDeleteCaCertificatePem
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteCaCertificatePem(false)}
          />
        )}

        {!!isModalDeleteClientSecret && (
          <ModalDeleteClientSecret
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteClientSecret(false)}
          />
        )}

        {!!isModalAddClientId && (
          <ModalAddClientId
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalAddClientId(false)}
          />
        )}

        {!!isModalDeleteClientId && (
          <ModalDeleteClientId
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteClientId(false)}
          />
        )}

        {!!isModalAddAuthorizeCode && (
          <ModalAddAuthorizeCode
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalAddAuthorizeCode(false)}
          />
        )}

        {!!isModalDeleteAuthorizeCode && (
          <ModalDeleteAuthorizeCode
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteAuthorizeCode(false)}
          />
        )}


        {!!isModalAddAccountNumber && (
          <ModalAddAccountNumber
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalAddAccountNumber(false)}
          />
        )}

        {!!isModalDeleteAccountNumber && (
          <ModalDeleteAccountNumber
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalDeleteAccountNumber(false)}
          />
        )}


        {!!isModalGetOrganization && (
          <ModalGetOrganization
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalGetOrganization(false)}
          />
        )}

        {!!isModalGetTransactions && (
          <ModalGetTransactions
            successfulRequest={() => setIsUpdateObject(!isUpdateObject)}
            handleClose={() => setIsModalGetTransactions(false)}
          />
        )}

      </div>
    </ScrollBlock>
  );
}

export default IntegrationAlfabankPage;
